import React from "react";
import {
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Button,
  Box,
  Chip,
} from "@mui/material";
import { Link } from "react-router-dom";
import img1 from "../../pictures/img1.jpg";
import img2 from "../../pictures/img3.jpg";

function OngoingProjects() {
  const projects = [
    {
      id: 1,
      title: "Residential Independent Duplex",
      clientName: "Dr.Balachandran",
      image: img1,
      location: "Nolambur",
      status: "Ongoing",
      area: "9000 Sq.ft",
      structure: "Stilt + 3 Floors",
      category: "Residential Duplex",
      shortDescription:
        "Premium residential independent duplex project currently under execution at Nolambur.",
      overview:
        "This ongoing residential duplex project at Nolambur is being developed for Dr. Balachandran across approximately 9000 sq.ft with a stilt + 3 floor configuration. The work includes structural construction, space planning, and premium residential execution.",
      works: [
        "Residential independent duplex construction",
        "Stilt + 3 floor structural development",
        "Site planning and civil execution",
        "Premium residential finishing works in progress",
      ],
    },
    {
      id: 2,
      title: "Independent Duplex Residence",
      clientName: "Mr. Sarath",
      image: img2,
      location: "Thirumazhisai",
      status: "Ongoing",
      area: "5600 Sq.ft",
      structure: "Ground + 2 Floors",
      category: "Independent Duplex",
      shortDescription:
        "Independent duplex residence under construction at Thirumazhisai.",
      overview:
        "This ongoing independent duplex project at Thirumazhisai is being executed for Mr. Sarathi over approximately 5600 sq.ft with a ground + 2 floor arrangement. The project focuses on practical residential planning, structural quality, and modern duplex living requirements.",
      works: [
        "Independent duplex house construction",
        "Ground + 2 floor execution",
        "Residential planning and structural work",
        "Construction and finishing works in progress",
      ],
    },
    {
      id: 3,
      title: "Commercial Office & Renovation Works",
      clientName: "Veyem Engineering Services",
      image: img1,
      location: "Ambattur",
      status: "Ongoing",
      area: "Commercial Project",
      structure: "Office / Renovation",
      category: "Commercial & Renovation",
      shortDescription:
        "Commercial office and house renovation works under progress at Ambattur.",
      overview:
        "Ongoing works for Veyem Engineering at Ambattur include commercial office-related construction activity along with house renovation works. The project involves coordinated execution for both commercial and residential improvement requirements.",
      works: [
        "Commercial office works",
        "House renovation works",
        "Site coordination and execution",
        "Multi-scope ongoing project support",
      ],
    },
  ];

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        py: { xs: 8, md: 12 },
        background:
          "linear-gradient(135deg, #dbe6ff 0%, #dce5ff 50%, rgb(167, 194, 255) 100%)",
      }}
    >
      {/* Animated background blobs */}
      <Box
        sx={{
          position: "absolute",
          top: "-120px",
          left: "-120px",
          width: 320,
          height: 320,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(26, 2, 163, 0.5), transparent 70%)",
          filter: "blur(30px)",
          animation: "floatOne 10s ease-in-out infinite",
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "-140px",
          right: "-100px",
          width: 360,
          height: 360,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(71,118,230,0.30), transparent 70%)",
          filter: "blur(40px)",
          animation: "floatTwo 14s ease-in-out infinite",
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "35%",
          left: "50%",
          transform: "translateX(-50%)",
          width: 260,
          height: 260,
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(255,255,255,0.10), transparent 70%)",
          filter: "blur(50px)",
          animation: "pulseGlow 8s ease-in-out infinite",
          zIndex: 0,
        }}
      />

      <Container sx={{ position: "relative", zIndex: 2 }}>
        <Typography
          variant="h3"
          textAlign="center"
          fontWeight={800}
          sx={{
            color: "#08027d",
            letterSpacing: 0.5,
            mb: 1.5,
            textShadow: "0 4px 20px rgba(0,0,0,0.35)",
          }}
        >
          Ongoing Projects
        </Typography>

        <Typography
          textAlign="center"
          sx={{
            color: "#08027d",
            maxWidth: 760,
            mx: "auto",
            mb: 7,
            lineHeight: 1.8,
          }}
        >
          Current projects under execution across residential duplex,
          independent housing, and commercial renovation works.
        </Typography>

        <Grid container spacing={4}>
          {projects.map((project) => (
            <Grid item xs={12} md={6} lg={4} key={project.id} display="flex">
              <Card
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  position: "relative",
                  borderRadius: "28px",
                  overflow: "hidden",
                  background: "rgba(255, 255, 255, 0.08)",
                  border: "1px solid rgba(255,255,255,0.15)",
                  backdropFilter: "blur(18px)",
                  WebkitBackdropFilter: "blur(18px)",
                  boxShadow:
                    "0 20px 60px rgba(0,0,0,0.35), inset 0 1px 0 rgba(255,255,255,0.12)",
                  transformStyle: "preserve-3d",
                  transition:
                    "transform 0.5s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.5s ease, border-color 0.4s ease",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    inset: 0,
                    background:
                      "linear-gradient(135deg, rgba(255,255,255,0.14), rgba(255,255,255,0.03))",
                    pointerEvents: "none",
                    zIndex: 1,
                  },
                  "&:hover": {
                    transform:
                      "perspective(1200px) rotateX(6deg) rotateY(-6deg) translateY(-12px) scale(1.02)",
                    boxShadow:
                      "0 28px 80px rgba(0,0,0,0.48), 0 0 30px rgba(255,190,92,0.12)",
                    borderColor: "rgba(255,210,140,0.35)",
                  },
                }}
              >
                <Box sx={{ position: "relative", overflow: "hidden" }}>
                  <CardMedia
                    component="img"
                    height="250"
                    image={project.image}
                    alt={project.title}
                    sx={{
                      transition: "transform 0.7s ease",
                      "&:hover": {
                        transform: "scale(1.08)",
                      },
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(to top, rgba(9,11,26,0.75), rgba(9,11,26,0.15), transparent)",
                    }}
                  />
                </Box>

                <CardContent
                  sx={{
                    position: "relative",
                    zIndex: 2,
                    p: 3,
                    color: "#08027d",
                    flexGrow: 1,
                  }}
                >
                  <Chip
                    label={project.status}
                    sx={{
                      mb: 2,
                      bgcolor: "rgba(255, 184, 77, 0.16)",
                      color: "#ffcc80",
                      fontWeight: 700,
                      border: "1px solid rgba(255, 204, 128, 0.35)",
                      backdropFilter: "blur(8px)",
                    }}
                  />

                  <Typography
                    variant="h6"
                    fontWeight={800}
                    sx={{ mb: 1, color: "#08027d" }}
                  >
                    {project.title}
                  </Typography>

                  <Typography sx={{ mb: 0.8, color: "#08027d" }}>
                    <strong>Client:</strong> {project.clientName}
                  </Typography>

                  <Typography sx={{ mb: 0.8, color: "#08027d" }}>
                    <strong>Location:</strong> {project.location}
                  </Typography>

                  <Typography sx={{ mb: 0.8, color: "#08027d" }}>
                    <strong>Area:</strong> {project.area}
                  </Typography>

                  <Typography sx={{ mb: 0.8, color: "#08027d" }}>
                    <strong>Structure:</strong> {project.structure}
                  </Typography>

                  <Typography
                    sx={{
                      color: "#08027d",
                      mt: 2,
                      lineHeight: 1.8,
                      minHeight: 72,
                    }}
                  >
                    {project.shortDescription}
                  </Typography>

                  <Box textAlign="center" mt={3}>
                    <Button
                      variant="contained"
                      component={Link}
                      to={`/project/${project.id}`}
                      state={{ project }}
                      sx={{
                        borderRadius: "999px",
                        px: 3.2,
                        py: 1.2,
                        textTransform: "none",
                        fontWeight: 700,
                        color: "#111827",
                        background:
                          "linear-gradient(135deg, #b6acff 0%, #0d0982 100%)",
                        boxShadow: "0 10px 24px rgba(80, 77, 255, 0.35)",
                        transition: "all 0.35s ease",
                        "&:hover": {
                          background:
                            "linear-gradient(135deg, #b2b5ff 0%, #4d62ff 100%)",
                          boxShadow: "0 16px 32px rgba(92, 77, 255, 0.45)",
                          transform: "translateY(-2px)",
                        },
                      }}
                    >
                      View Details
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      <style>
        {`
          @keyframes floatOne {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(40px, 30px) scale(1.12); }
          }

          @keyframes floatTwo {
            0%, 100% { transform: translate(0, 0) scale(1); }
            50% { transform: translate(-35px, -25px) scale(1.1); }
          }

          @keyframes pulseGlow {
            0%, 100% { opacity: 0.45; transform: translateX(-50%) scale(1); }
            50% { opacity: 0.7; transform: translateX(-50%) scale(1.18); }
          }
        `}
      </style>
    </Box>
  );
}

export default OngoingProjects;
